export default {
    type: 'panel',
    name: 'productList',
    blocks: [
        {
            name: 'title', // name or id; MUST be unique
            label: 'Titre',
            max: 1, // max same items allowed
            type: 'text',
        },
        {
            name: 'content',
            label: 'Introduction',
            max: 1,
            type: 'html',
        },
        {
            // Manual product selection (repeatable). Each item stores a product _id in `.text`.
            // When at least one product is picked here, it takes precedence over the category filter.
            name: 'products',
            label: 'Produits (sélection manuelle)',
            type: 'product',
        },
        {
            // Category/tag filter, used only when no manual product is selected. Repeatable, matched
            // against the product `categories` attribute (see PanelRecommandation).
            name: 'category',
            label: 'Catégories (filtre auto)',
            type: 'text',
        },
        {
            // Client group identifier (e.g. `pro`) driving the displayed price. Empty = current /
            // default group price.
            name: 'group',
            label: 'Groupe client (identifiant, ex: pro)',
            max: 1,
            type: 'text',
        },
        {
            // Number of products displayed in category (auto) mode. Ignored for manual selection.
            name: 'count',
            label: 'Nombre de produits (mode auto)',
            max: 1,
            type: 'text',
        },
        {
            name: 'viewType',
            label: 'Affichage',
            max: 1,
            type: 'select',
            options: ['grid', 'line', 'slider'],
        },
        {
            // Autoplay delay (ms) of the carousel, slider mode only. Empty = 7000.
            name: 'interval',
            label: 'Vitesse du slider en ms (mode slider)',
            max: 1,
            type: 'text',
        },
    ],
};
